import React from 'react'
import { useNavigate } from 'react-router'

import {
  useProposalAdjustment,
  useProposalFormData,
} from '../../../../hooks/adjustments/proposal'
import {
  TExtends,
  TKey,
  useWriskTranslation,
} from '../../../../infrastructure/internationalisation'
import { useUpButton } from '../../../../infrastructure/routing'
import { FormErrors } from '../../../formBuilder'
import { FullPage } from '../../../templates'
import { useProduct } from '../../productContext'
import { useCheckout } from './CheckoutProvider'

const tKey = TKey('pages.final-mile')

export const FinalMilePage = () => {
  const { t } = useWriskTranslation()

  const navigate = useNavigate()

  const {
    product: { checkout },
  } = useProduct()

  const { previous, next } = useCheckout()

  const inputs = checkout?.finalMile ?? []
  const data = useProposalFormData(inputs)

  const upButton = useUpButton(previous)

  const { execute, loading } = useProposalAdjustment({
    form: inputs,
    applyRating: false,
    onComplete: () => navigate(next.url),
  })

  return (
    <FullPage
      pageId='final-mile-page'
      header={t(tKey('header'))}
      subheader={t(tKey('subheader'), { defaultValue: null })}
      upButton={upButton}
    >
      <FormErrors
        id='final-mile'
        data={data}
        config={inputs}
        onSubmit={execute}
        loading={loading}
        tKey={TExtends(tKey, 'form')}
        footerText='footer'
        t={t}
      />
    </FullPage>
  )
}
